import { CbhIcon, type CbhIconProps } from "@src/appV2/redesign/system/ui-components";

import { type NewsFeedItemReactionEmoji } from "./types";

const EMOJI_ICON_MAP: Record<
  NewsFeedItemReactionEmoji,
  { icon: CbhIconProps["type"]; color: CbhIconProps["color"] }
> = {
  AWARD_BUNNY: { icon: "star-filled", color: (theme) => theme.palette.intent?.warning.icon },
  CHAMPAGNE_BUNNY: { icon: "bolt-filled", color: (theme) => theme.palette.intent?.neutral.icon },
  HEART_BUNNY: { icon: "like-filled", color: (theme) => theme.palette.intent?.error.icon },
  MONEY_BUNNY: { icon: "coin", color: (theme) => theme.palette.intent?.success.icon },
};

interface NewsFeedItemReactionEmojiIconProps {
  emoji: NewsFeedItemReactionEmoji;
  onClick?: (emoji: NewsFeedItemReactionEmoji) => void;
}

export function NewsFeedItemReactionEmojiIcon(props: NewsFeedItemReactionEmojiIconProps) {
  const { emoji, onClick = () => undefined } = props;

  return (
    <CbhIcon
      aria-label={`${emoji} reaction`}
      type={EMOJI_ICON_MAP[emoji].icon}
      color={EMOJI_ICON_MAP[emoji].color}
      onClick={() => {
        onClick(emoji);
      }}
    />
  );
}
